/** Format the first trustworthy timestamp from provider, webhook receipt, or message creation. */
export function formatDeliveryTime(...candidates: (string | null | undefined)[]): string {
  for (const value of candidates) {
    if (!value) continue;
    const date = new Date(value);
    // Some providers use the Unix epoch as a placeholder when they have no event time.
    if (!Number.isNaN(date.getTime()) && date.getUTCFullYear() >= 2020) return date.toLocaleString('th-TH');
  }
  return '—';
}
